import { useTranslation } from "react-i18next";
import { SectionTitle } from "@/components/ui/SectionTitle";

import { type ReactNode } from "react";
import { TeamComposer } from "./team-composer";

export const TeamFormationForm = ({ teamId }: { teamId?: string }) => {
  const { t } = useTranslation(["common", "teams"]);
  return (
    <section className="h-full flex flex-col min-h-0">
      <SectionTitle
        title={t("common:a11y.team_formation")}
        lead={t("teams:formation.lead")}
        noMarginBottom
        className="mb-4"
      />
      <TeamComposer teamId={teamId} />
    </section>
  );
};

export const BlockHeader = ({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) => {
  return (
    <div
      className={`bg-primary/10 border-b flex-none px-4 h-14 flex items-center ${className}`}
    >
      {children}
    </div>
  );
};
